module.exports = __webpack_public_path__ + "img/secure.e4578b3d.png";